// This file was auto-generated by Fern from our API Definition.
export const ChannelKeyGrain = {
    Connection: "connection",
    Space: "space",
    Thread: "thread",
};
